module.exports = __webpack_public_path__ + "img/actionGet.49c7c251.png";